export default "assets/images/icons/cart-8f3be699.svg";